export const projects = [
    {
      title: "IA Manager — Vivo (Telefônica)",
      year: "2026",
      featured: true,
      description: "Plataforma de observabilidade de IA que monitora 6 milhões de conversas/dia (100M+ usos mensais) entre a IA da Vivo e atendentes humanos, com encaminhamento inteligente e relatórios analíticos. Lidero tecnicamente equipe de 10 devs. Stack: TypeScript, LangChain, NLP, LLMs, Elasticsearch e integrações com SDKs corporativos (Aura/AutoPilot).",
      tech: ["LangChain", "TypeScript", "Elasticsearch", "LLMs", "NLP"],
      videoUrl: "",
      repoUrl: "",
      hasVideo: false,
      hasRepo: false
    },
    {
      title: "Cactvs v3.0 — IA Antifraude",
      year: "2025",
      featured: true,
      description: "Versão 3.0 do sistema de liberação de crédito da Cactvs (instituição financeira em conformidade com a CAIXA, 200k+ clientes). Adicionei camada de IA para validar preços de gado, cultivos e ativos rurais, detectando superfaturamento. Resultado: redução de 80% nas fraudes de superfaturamento após o lançamento.",
      tech: ["Node.js", "IA", "PostgreSQL", "Flutter"],
      videoUrl: "",
      repoUrl: "",
      hasVideo: false,
      hasRepo: false
    },
    {
      title: "GS Space",
      year: "2025",
      featured: true,
      description: "Rede social focada na comunidade Pokémon GO, com 30.000+ usuários ativos publicada na Play Store e App Store. Inclui posts, stories, reels, grupos, salas de voz em tempo real e chats privados, inspirada no Instagram. Stack: Flutter + Node.js + PHP, com Firebase, Agora, FCM, Sightengine (moderação), DigitalOcean e Branch.io em arquitetura escalável.",
      tech: ["Flutter", "Node.js", "PHP", "Firebase", "Agora"],
      videoUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7320505612914573314/",
      repoUrl: "https://play.google.com/store/apps/details?id=com.goshiny.space&hl=pt_BR",
      hasVideo: true,
      hasRepo: true
    },
    {
      title: "Sticky — IA Generativa",
      year: "2024",
      featured: false,
      description: "Engenharia e governança de sistemas baseados em LLMs para criação de jogos pelo usuário. Pipelines de geração de personagens e narrativas interativas com memória contextual e consistência comportamental; guardrails de validação de entrada, moderação e restrição de intenção; e roteamento inteligente que escolhe o modelo por tipo de tarefa (chat, narrativa, estruturação, refinamento), equilibrando qualidade, custo e latência.",
      tech: ["Next.js", "Node.js", "LLMs", "Guardrails", "Prompt Engineering"],
      videoUrl: "",
      repoUrl: "",
      hasVideo: false,
      hasRepo: false
    },
    {
      title: "AgroFácil — SaaS Multi-Tenant",
      year: "2024",
      featured: false,
      description: "SaaS multi-tenant de gestão agrícola: plataforma completa cobrindo cultivos, rebanho, safras, estoque, maquinário, financeiro e KPIs, com schema de 50+ entidades relacionadas. Inclui isolamento por tenant, RBAC, Stripe para pagamentos recorrentes e alertas climáticos automáticos via OpenWeather.",
      tech: ["React", "TypeScript", "Node.js", "Express", "Prisma", "PostgreSQL", "Stripe"],
      videoUrl: "",
      repoUrl: "",
      hasVideo: false,
      hasRepo: false
    },
    {
      title: "Doran ERP — Saúde e Segurança do Trabalho",
      year: "2024",
      featured: false,
      description: "ERP de SST cobrindo funcionários, gestão de EPIs (com controle de CA e validade), treinamentos obrigatórios (NRs), exames ocupacionais (PCMSO) e plataforma EAD com certificados. Implementei a entrega de EPIs com assinatura biométrica via WebAuthn, auditoria imutável em conformidade com a LGPD e alertas automáticos por e-mail/WhatsApp.",
      tech: ["React 19", "TypeScript", "Hono", "Drizzle ORM", "WebAuthn"],
      videoUrl: "",
      repoUrl: "https://sst-erp-production.up.railway.app/",
      hasVideo: false,
      hasRepo: true
    },
    {
      title: "Único Escritório",
      year: "2026",
      featured: false,
      description: "SaaS multi-tenant modularizado para escritórios, com foco jurídico. Módulos independentes de Processos (sincronização DataJud/DJEN), Financeiro (acordos e parcelamentos), RH (banco de horas CLT), Comercial/CRM, Portal do Cliente e Assistente Jurídico com IA. Stack: React + TypeScript sobre Supabase (Postgres com RLS) e Edge Functions.",
      tech: ["React", "TypeScript", "Supabase", "PostgreSQL", "Edge Functions", "IA"],
      videoUrl: "",
      repoUrl: "https://unicoescritorio.com/",
      hasVideo: false,
      hasRepo: true
    },
    {
      title: "Agente de IA para Atendimento (RAG)",
      year: "2024",
      featured: false,
      description: "Agente conversacional para atendimento automatizado via WhatsApp em Python/FastAPI, com pipeline de RAG usando embeddings OpenAI e busca vetorial (pgvector) no Supabase. Base de conhecimento isolada por cliente, guardrails de segurança (moderação, anti-jailbreak, rate limiting) e handoff automático para humano por similaridade semântica.",
      tech: ["Python", "FastAPI", "RAG", "pgvector", "Supabase", "OpenAI"],
      videoUrl: "",
      repoUrl: "",
      hasVideo: false,
      hasRepo: false
    },
    {
      title: "VideoCasa Pro",
      year: "2024",
      featured: false,
      description: "SaaS para criação de vídeos de imóveis com IA generativa. Geração de vídeos via RunwayML, edição e renderização com FFmpeg, front-end em Next.js e back-end em NestJS.",
      tech: ["Next.js", "NestJS", "RunwayML", "FFmpeg", "TypeScript"],
      videoUrl: "",
      repoUrl: "",
      hasVideo: false,
      hasRepo: false
    },
    {
      title: "GoShiny",
      year: "2023",
      featured: false,
      description: "App Flutter para jogadores de Pokémon GO participarem de raids à distância, com salas para conexão. Inclui widget que atualiza em tempo real a coordenada de um YouTuber via script e exibe anúncios do Google AdMob.",
      tech: ["Flutter", "Firebase", "Google AdMob"],
      videoUrl: "https://youtu.be/U5uNY-y88f8",
      repoUrl: "https://play.google.com/store/apps/details?id=br.com.goshiny&hl=pt_BR",
      hasVideo: true,
      hasRepo: true
    },
    {
      title: "Music Game",
      year: "2023",
      featured: false,
      description: "Jogo interativo onde você pode testar seus conhecimentos musicais ouvindo trechos de músicas e tentando adivinhar qual é a correta.",
      tech: ["JavaScript", "HTML5", "CSS3"],
      videoUrl: "https://www.linkedin.com/posts/bernardo-assad_ol%C3%A1-rede-como-voc%C3%AAs-est%C3%A3o-acabei-de-criar-activity-7295109784737869825-exRN?utm_source=share&utm_medium=member_desktop&rcm=ACoAADoZJDwBcEsLAoF6MKF7f5ZBcpHYBM6Nfos",
      repoUrl: "https://github.com/BernardoAssad/music-game",
      hasVideo: true,
      hasRepo: true
    }
];
